import { render, staticRenderFns } from "./import-substitution-request-show.vue?vue&type=template&id=dbe2ab46&"
import script from "./import-substitution-request-show.vue?vue&type=script&lang=js&"
export * from "./import-substitution-request-show.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/stage-dev2/front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('dbe2ab46')) {
      api.createRecord('dbe2ab46', component.options)
    } else {
      api.reload('dbe2ab46', component.options)
    }
    module.hot.accept("./import-substitution-request-show.vue?vue&type=template&id=dbe2ab46&", function () {
      api.rerender('dbe2ab46', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/import-substitution/import-substitution-request-show.vue"
export default component.exports